import * as React from 'react';
import { PivotItem, IPivotItemProps } from 'office-ui-fabric-react/lib/Pivot';
import { InboxClassificationFilter } from 'owa-mail-list-store';
import { getInboxPlusPivotDisplayProperties } from 'owa-mail-inbox-plus-store';
import { convertClassificationFiltertoPivotKey } from './InboxPlusHeader';

export default function renderInboxPivotItem(pivotType: InboxClassificationFilter): JSX.Element {
    const displayProperties = getInboxPlusPivotDisplayProperties(pivotType);

    return (
        <PivotItem
            headerText={displayProperties.displayText}
            itemKey={convertClassificationFiltertoPivotKey(pivotType)}
            onRenderItemLink={(link, defaultRenderer) =>
                renderDroppablePivot(link, defaultRenderer)
            }
            itemIcon={displayProperties.icon}
        />
    );
}

function renderDroppablePivot(
    link: IPivotItemProps,
    defaultRenderer: (link: IPivotItemProps) => JSX.Element
): JSX.Element {
    return <>{defaultRenderer(link)}</>;
}
